/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles/base-blog-related-articles.fragment';
import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';

export const BlogRelatedArticlesFragment = gql`
  ${BaseBlogFragment}
  ${BaseBlogRelatedArticlesFragment}

  fragment BlogRelatedArticlesFragment on BlogRelatedArticles {
    ...BaseBlogRelatedArticlesFragment

    blogTagsCollection {
      items {
        __typename
        ... on Blog {
          ...BaseBlogFragment
        }
      }
    }
    blogTagsCursorCollection {
      items {
        __typename
        ... on Blog {
          ...BaseBlogFragment
        }
      }
    }
  }
`;
